export default {
  zipcode: "Zipcode",
  addZipcode: "AddZipcode",
  editZipcode: "EditZipcode",
};
